import { redirect } from 'react-router-dom';
import GET_LANDING_QUERY from '../queries/landing/getLanding.graphql';

const handleRedirects = (data) => {
  const newSlug = data?.newSlug || data?.data?.landing?.newSlug;
  const hasError = data?.hasError || data?.data?.landing?.hasError;

  if (newSlug) {
    return redirect(newSlug);
  }

  if (hasError) {
    return redirect('/');
  }

  return data;
};

const landingLoader = async ({ apolloClient, request }) => {
  const { url } = request;
  const { pathname } = new URL(url);

  const data = await apolloClient.query({
    query: GET_LANDING_QUERY,
    variables: {
      path: pathname
    }
  });

  return handleRedirects(data);
};

export default landingLoader;
